import MuiWhatsApp from '@mui/icons-material/WhatsApp';
import * as React from 'react';

import { Icon, type IconProps } from '../base-icon';

export const IconWhatsApp = React.forwardRef<SVGSVGElement, IconProps>(
    (props, ref) => (
        <Icon
            ref={ref}
            iconComponent={MuiWhatsApp}
            outlineComponent={MuiWhatsApp}
            roundedComponent={MuiWhatsApp}
            {...props}
        />
    )
);
